<template>
  <svg
    width="86"
    height="86"
    viewBox="0 0 86 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M70.6799 17.8949C75.7522 24.9459 78.7396 33.5973 78.7396 42.9463C78.7396 52.2954 75.7522 60.9467 70.6799 67.9978M56.3555 28.6312C59.1858 32.689 60.8457 37.6238 60.8457 42.9463C60.8457 48.2689 59.1858 53.2037 56.3555 57.2614M34.4856 19.2036L23.1563 30.5329C22.5373 31.1518 22.2279 31.4613 21.8667 31.6826C21.5465 31.8788 21.1974 32.0234 20.8322 32.1111C20.4204 32.21 19.9827 32.21 19.1074 32.21H12.8901C10.8858 32.21 9.88365 32.21 9.11811 32.6001C8.44472 32.9432 7.89724 33.4906 7.55413 34.164C7.16406 34.9296 7.16406 35.9317 7.16406 37.936V47.9566C7.16406 49.9609 7.16406 50.9631 7.55413 51.7286C7.89724 52.402 8.44472 52.9495 9.11811 53.2926C9.88365 53.6827 10.8858 53.6827 12.8901 53.6827H19.1074C19.9827 53.6827 20.4204 53.6827 20.8322 53.7815C21.1974 53.8692 21.5465 54.0138 21.8667 54.21C22.2279 54.4313 22.5373 54.7408 23.1563 55.3598L34.4856 66.6891C36.0186 68.2221 36.7852 68.9886 37.4433 69.0404C38.0143 69.0854 38.5723 68.8542 38.9443 68.4187C39.3731 67.9167 39.3731 66.8327 39.3731 64.6646V21.2281C39.3731 19.06 39.3731 17.9759 38.9443 17.474C38.5723 17.0384 38.0143 16.8073 37.4433 16.8522C36.7852 16.904 36.0186 17.6705 34.4856 19.2036Z"
      :stroke="color"
      stroke-width="7.15755"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: "#475467",
  },
});
</script>
